module.exports = __webpack_public_path__ + "img/logo-dpi.b045738d.png";